const SYSTEM_ROLE_TYPES = {
    ADMIN: 'ADMIN',
    END_USER: 'END_USER',
    IMPERSONATED: 'IMPERSONATED',
};

export default SYSTEM_ROLE_TYPES;